import { SUPPORT_MAILTO } from "@/lib/company";
import { useI18n } from "@/i18n";

// Small shared "need help?" line shown under authenticated screens.
export function SupportLine() {
  const { t } = useI18n();
  return (
    <div className="mt-10 border-t border-re-line pt-6 text-center text-sm text-re-muted" data-testid="support-line">
      {t("support.needHelp")}{" "}
      <a href={SUPPORT_MAILTO} className="font-semibold text-re-red hover:underline" data-testid="support-link">
        {t("support.contact")}
      </a>
    </div>
  );
}
